import * as R from 'ramda';
import { connect } from 'react-redux';
import { withProps, compose, withStateHandlers } from 'recompose';
import { createSelector } from 'reselect';
import RiskRatings from './../components/RiskRatings';
import getUserPreferences from 'selectors/getUserPreferences';
import riskRatingCategories from 'consts/riskRatingCategories';
import { selectors as ratingsSelectors } from './../ducks/userRiskRatings.duck';

const getUserRiskTypes = R.pipe(
  getUserPreferences,
  R.path(['dashboardRatings', 'riskTypes']),
);

const getRiskRatings = createSelector(
  getUserRiskTypes,
  (userRiskTypes: string[]) =>
    R.pipe(
      R.ifElse(
        R.either(
          R.always(R.isNil(userRiskTypes)),
          R.always(R.isEmpty(userRiskTypes)),
        ),
        R.identity,
        R.filter(({ id }) => R.contains(id, userRiskTypes)),
      ),
      R.map(
        R.applySpec({
          value: R.prop('id'),
          label: R.prop('title'),
        }),
      ),
    )(riskRatingCategories),
);

const getItems = createSelector(
  ratingsSelectors.data,
  (geographies: {}) => (
    R.pipe(
      R.map(
        R.pipe(
          R.prop('geography'),
          R.applySpec({
            slug: R.prop('slug'),
            label: R.prop('title'),
            iso: R.prop('iso'),
            rating: R.pipe(
              R.prop('risk'),
            ),
            to: {
              type: R.always('COUNTRIES_GEOGRAPHY'),
              payload: {
                geography: R.prop('slug'),
              },
            },
          }),
        ),
      ),
      R.values,
    )(geographies)
  ),
);

const UserRiskRatings = compose(
  connect(R.applySpec({
    items: getItems,
    loading: ratingsSelectors.loading,
    riskRatings: getRiskRatings,
  })),
  withStateHandlers(
    props => ({
      selectedRisk: R.path([
        'riskRatings', 0, 'value',
      ])(props),
    }),
    {
      setActive: () => slug => ({
        selectedRisk: slug,
      }),
    },
  ),
  withProps((ownProps: { items: object[] }) => R.evolve({
    items: R.map(
      R.applySpec({
        label: R.prop('label'),
        iso: R.prop('iso'),
        to: R.prop('to'),
        rating: R.path([
          'rating',
          R.prop('selectedRisk', ownProps),
          'normalisedRisk',
        ]),
        ratingType: R.path([
          'rating',
          R.prop('selectedRisk', ownProps),
        ]),
        ratingLabel: R.path([
          'rating',
          R.prop('selectedRisk', ownProps),
          'title',
        ]),
      }),
    ),
  })(ownProps)),
)(RiskRatings);

export default UserRiskRatings;

